import { TFilterSettings } from "#next/utils/shared";
import { Grid } from "@mui/material";
import { PlatformPackageSelector } from "#next/components/search-builder/PlatformPackageSelector";
import { Toolbar } from "#next/components/search-builder/Toolbar";

export const SearchFilter = ({
  initialSettings,
  onSettingsChange,
}: {
  initialSettings: TFilterSettings;
  onSettingsChange: ({
    settings,
    settingsAreValid,
  }: {
    settings: TFilterSettings;
    settingsAreValid: boolean;
  }) => void;
}) => {
  if (initialSettings.platforms.include.length === 0) {
    return (
      <Toolbar>
        No platforms assigned to your organization. Please contact Pyrra
        support.
      </Toolbar>
    );
  }

  return (
    <Grid container direction="row">
      <Grid item>
        <PlatformPackageSelector
          initialSettings={initialSettings.platforms.include}
          onSettingsChange={({ platformPackages, settingsAreValid }) => {
            onSettingsChange({
              settings: {
                ...initialSettings,
                platforms: { include: platformPackages },
              },
              settingsAreValid,
            });
          }}
        />
      </Grid>
    </Grid>
  );
};
